import React, { useEffect } from "react";
import Cookies from "universal-cookie";

import HeaderComponent from "./HeaderComponent";
import Routing2 from "../../Routing2";
import { SideBar } from "../Sidebar";
import NewSideBar from "../Sidebar/NewSideBar";
import { Route, Routes } from "react-router-dom";
import RestaurantReport from "../Reports/RestaurantReport";
import SideBarNew from "../Sidebar/SideBarNew";

const NavigationComponent = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get("at");
    const directLogin = urlParams.get("dl");

    const cook = new Cookies().get("loginData1");
    useEffect(() => {
        document.querySelectorAll("a[href^='#']").forEach((node) => {
            node.addEventListener("click", (e) => {
                e.preventDefault();
            });
        });
        var cook = new Cookies();
        if (cook.get("loginData1") === null) {
            const cookies = new Cookies();
            cookies.remove("loginData1");
            window.location.reload(1);
        }
        var currentURI = window.location.pathname;
        if (currentURI.split("/")[3] === "taxrates") {
        }
    }, []);

    if (cook?.directLogin || directLogin) {
        return (
            <Routes>
                <Route path="/restaurant/reports" element={<RestaurantReport />} />
            </Routes>
        );
    } else {
        return (
            <div style={{display:"flex",flexDirection:"column"}}>
                <div>
                    <HeaderComponent />
                </div>
                <div style={{display:"flex",width:"100%",top:"0 !important"}}>
                    <div>
                        {/* {/ <SideBar /> /} */}
                        <SideBarNew />
                    </div>
                    <div style={{width:"100%"}}>
                        {/* {/ <NewSideBar /> /} */}
                        <Routing2 />
                    </div>
                </div>
            </div>
        );
    }
};

export default NavigationComponent;
